import { render, staticRenderFns } from "./TwoFactorAuthDisableModal.vue?vue&type=template&id=669af287&scoped=true&"
import script from "./TwoFactorAuthDisableModal.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthDisableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669af287",
  null
  
)

export default component.exports